function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { roterPre } from '@/settings';
import { fileLinkDownLoad } from '@/libs/public';
import { folderAllDeleteApi, folderAllDestroyApi, folderAllDestroyFileApi, folderSpaceEntAllDeleteApi, folderSpaceEntAllDestroyApi, folderSpaceEntAllRecoverApi } from '@/api/cloud';
export default {
  name: 'CloudFile',
  components: {
    cloudfileLeft: function cloudfileLeft() {
      return import('./components/layout/cloudfileLeft');
    },
    // 左侧导航
    formBox: function formBox() {
      return import('./components/layout/formBox');
    },
    // 顶部操作
    latelyFile: function latelyFile() {
      return import('./components/layout/latelyFile');
    },
    // 最近的文件
    recoveryFile: function recoveryFile() {
      return import('./components/layout/recoveryFile');
    },
    // 回收站的文件
    spaceFile: function spaceFile() {
      return import('./components/layout/spaceFile');
    },
    // 企业空间文件
    newFileDialog: function newFileDialog() {
      return import('./components/newFileDialog');
    },
    // 新建文件弹窗
    moveDialog: function moveDialog() {
      return import('./components/moveDialog');
    },
    // 移动文件弹窗
    fileTemp: function fileTemp() {
      return import('./components/fileTemp');
    },
    // 文件模板弹窗
    fileDialog: function fileDialog() {
      return import('@/components/openFile/previewDialog ');
    } // 图片、MP3，MP4弹窗
  },
  data: function data() {
    return {
      fileStyle: {
        style: 1,
        sort: 1,
        type: 1,
        keyword: '',
        sortBy: 6
      },
      total: 0,
      gridl: {
        xl: 3,
        lg: 4,
        md: 5,
        sm: 6,
        xs: 24
      },
      gridr: {
        xl: 21,
        lg: 20,
        md: 19,
        sm: 18,
        xs: 24
      },
      type: '1',
      spaceType: '',
      // 判断是否是最近打开
      breadcrumbArray: [],
      // 面包屑文字
      switchIndex: 1,
      configMyFile: {},
      pid: 0,
      spaceId: 0,
      entButton: false,
      uploadLoading: false,
      ids: [],
      moveData: {
        id: [],
        type: 2
      },
      fileData: {},
      fileTemp: {
        type: 1,
        title: this.$t('file.selecttemplate'),
        width: '820px'
      },
      isSortShow: false,
      pageLimit: 0,
      wps_type: JSON.parse(localStorage.getItem('webConfig')).wps_type || '0'
    };
  },
  watch: {
    lang: function lang() {
      this.setOptions();
    },
    'fileStyle.style': function fileStyleStyle(val) {
      var _this = this;
      var windowHeight = document.documentElement.clientHeight - 284;
      //大图模式，根据页面高度计算每页数据条数，这里可以根据实际需求进行适当的调整
      if (val == 2) {
        var winWidth = document.getElementById('cloudfile-right').offsetWidth;
        var col = Math.floor(winWidth / 130);
        var row = Math.floor(windowHeight / 154);
        this.pageLimit = col * row;
      } else {
        var height = document.documentElement.clientHeight - 284;
        this.pageLimit = Math.floor(height / 52);
      }
      setTimeout(function () {
        _this.getFileList();
      }, 200);
    }
  },
  mounted: function mounted() {
    var _this2 = this;
    this.$nextTick(function () {
      var height = document.documentElement.clientHeight - 284;
      _this2.pageLimit = Math.floor(height / 52); // 假设每行高度为 50px
    });
  },
  methods: {
    isUploading: function isUploading() {
      this.uploadLoading = true;
    },
    isUploaded: function isUploaded() {
      this.uploadLoading = false;
    },
    handleClick: function handleClick(e) {
      // this.$refs.shareFile.shareIndex = e.name
      // this.$refs.shareFile.getTreeData()
    },
    // 点击item项
    openfile: function openfile(item) {
      var fid = item.pid || this.spaceId;
      var fileType = item.file_ext;
      var types = ['jpeg', 'gif', 'bmp', 'png', 'jpg', 'svg', 'mp3', 'mp4'];
      var downloadType = ['xmind', 'zip', 'xls'];
      var isImage = types.includes(fileType);
      // 打开word类型文件
      if (!isImage && !downloadType.includes(fileType)) {
        var url = "".concat(roterPre, "/openFile?id=").concat(item.id, "&&fid=").concat(item.pid || this.spaceId);
        window.open(url, '_blank');
      } else if (downloadType.includes(fileType)) {
        fileLinkDownLoad(item.file_url, item.file_name);
      } else {
        // 打开图片,音频，视频类型文件
        this.$refs.viewFile.openFile(fid, item.id);
      }
    },
    // 分享文件
    shareFile: function shareFile(item) {
      var origin = window.location.origin;
      var fileType = item.file_ext;
      var types = ['jpeg', 'gif', 'bmp', 'png', 'jpg', 'mp3', 'mp4'];
      var isImage = types.includes(fileType);
      // 打开word类型文件
      var url = '';
      if (!isImage) {
        url = "".concat(origin, "/admin/openFile?id=").concat(item.id, "&&fid=").concat(item.pid || this.spaceId);
      } else {
        // 打开图片,音频，视频类型文件
        url = item.file_url;
      }
      var realName = JSON.parse(localStorage.getItem('userInfo'));
      var oInput = document.createElement('input');
      var value = '【' + realName.name + '】分享给您【' + item.name + '】' + '请点击链接打开!' + url;
      oInput.value = value;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand('Copy');
      oInput.style.display = 'none';
      document.body.removeChild(oInput);
      this.$message.success('复制分享链接成功，请前去粘贴使用');
    },
    formBoxClick: function formBoxClick(type, val, index) {
      if (type === 'allMove') {
        // 移动至
        this.allMove();
      } else if (type === 'allDelete') {
        // 删除
        this.allDelete(val);
      } else if (type === 'handleClick') {
        // 共享相关操作
        this.handleClick(val);
      } else if (type === 'handleScreen') {
        // 我的文件相关操作
        this.handleScreen(val);
      } else if (type === 'handleScreen') {
        // 我的文件相关操作
        this.handleScreen(val);
      } else if (type === 'getBreadcrumb') {
        // 点击面包屑
        this.getBreadcrumb(val, index);
      } else if (type === 'styleChage') {
        // 文件样式变化
        this.styleChage(val, index);
      } else if (type === 'handleType') {
        // 文件类型筛选
        this.handleType(val);
      } else if (type === 'handleSuccess') {
        // 上传文件成功
        this.handleSuccess(val);
      } else if (type === 'recoveryBtn') {
        // 打开回收站
        this.recoveryBtn();
      }
    },
    styleChage: function styleChage(val, type) {
      this.fileStyle = val;
      if (!type) {
        this.getFileList();
      }
    },
    totalFn: function totalFn(val) {
      this.total = val;
    },
    // 列表搜索
    getFileList: function getFileList() {
      if (this.switchIndex === 1) {
        this.$refs.latelyFile.getTreeData(1); // 最近访问
      } else if (this.switchIndex === 6) {
        this.$refs.spaceFile.getTreeData(1); // 企业空间文件
        this.$refs.spaceFile.menuIds = [];
      } else if (this.switchIndex === 7) {
        this.$refs.recoveryFile.getTreeData(); // 回收站
        this.$refs.recoveryFile.menuIds = [];
      }
      this.ids = [];
    },
    backFn: function backFn() {
      this.switchIndex = 1;
    },
    confirmData: function confirmData(data, item) {
      var _this3 = this;
      this.fileStyle.keyword = '';
      if (item === 'recently') {
        // 最近访问
        this.switchIndex = 1;
        this.spaceType = item;
        this.breadcrumbArray = [];
        setTimeout(function () {
          _this3.$refs.latelyFile.getTreeData(item);
        }, 300);
        return false;
      } else if (item == 'recovery') {
        // 回收站
        this.switchIndex = 7;
        this.spaceType = item;
        this.breadcrumbArray = [];
        setTimeout(function () {
          _this3.$refs.recoveryFile.getTreeData(item);
        }, 300);
        return false;
      } else {
        // 空间文件
        this.switchIndex = data.selectIndex;
        this.spaceType = '';
        this.breadcrumbArray = [];
        this.breadcrumbArray.push(item);
      }
      if (data.type === 2) {
        // this.getFileList()
      } else {
        this.type = '1';
        this.spaceId = data.id;
        if (data.selectIndex == 6) {
          this.pid = 0;
          this.entButton = true;
          setTimeout(function () {
            _this3.$refs.spaceFile.where.pid = '';
            _this3.$refs.spaceFile.breadcrumbArray = [{
              name: _this3.$t('file.allfiles'),
              pid: ''
            }];
            _this3.$refs.spaceFile.checked = false;
            _this3.$refs.spaceFile.menuIds = [];
            _this3.$refs.spaceFile.where.page = 1;
            if (_this3.spaceId) {
              _this3.$refs.spaceFile.getTreeData(item);
            } else {
              _this3.$refs.spaceFile.fileData = [];
            }
          }, 200);
        } else {
          this.entButton = false;
        }
      }
    },
    // 点击面包屑
    getBreadcrumb: function getBreadcrumb(id, index) {
      var _this4 = this;
      setTimeout(function () {
        _this4.$refs.spaceFile.getBreadcrumb(id, index);
      }, 200);
      this.$nextTick(function () {
        _this4.breadcrumbArray.splice(index + 1, _this4.breadcrumbArray.length - index);
        _this4.$refs.spaceFile.breadcrumbArray = JSON.parse(JSON.stringify(_this4.breadcrumbArray));
      });
    },
    // 排序
    handleCommand: function handleCommand(command) {
      this.fileStyle.sort = command;
      this.getFileList();
    },
    // 排序
    handleSort: function handleSort(index, id) {
      this.fileStyle.sortBy = id;
      this.getFileList();
    },
    // 类型
    handleType: function handleType(command) {
      this.fileStyle.type = command;
      this.getFileList();
    },
    handleScreen: function handleScreen(command) {
      if (command == 5) {
        this.configMyFile = {
          title: this.$t('file.newfolder'),
          pid: this.pid,
          command: command,
          switch: this.switchIndex,
          spaceId: this.spaceId,
          type: ''
        };
        this.$refs.newFileDialog.handleOpen();
      } else if (command == 7) {
        this.handleTemp();
      } else {
        var title = '';
        var type = '';
        if (command == 1) {
          title = this.$t('file.newdocument');
          type = 'word';
        } else if (command == 2) {
          title = this.$t('file.newtable');
          type = 'excel';
        } else {
          title = this.$t('file.newslide');
          type = 'ppt';
        }
        this.configMyFile = {
          title: title,
          pid: this.pid,
          command: command,
          switch: this.switchIndex,
          spaceId: this.spaceId,
          type: type
        };
        this.$refs.newFileDialog.handleOpen();
      }
    },
    // 新建企业空间
    addEntSpace: function addEntSpace() {
      this.$refs.cloudfileLeft.addName();
    },
    handleTemp: function handleTemp() {
      if (this.entButton) {
        // 企业空间
        this.fileTemp.type = 2;
        this.fileTemp.fid = this.spaceId;
      } else {
        this.fileTemp.type = 1;
      }
      this.fileTemp.id = this.pid;
      this.$refs.fileTemp.handleOpen();
    },
    handlerMyFile: function handlerMyFile(data, item) {
      if (item) {
        this.breadcrumbArray.push(item);
      }
      if (data.type === 2) {
        this.$refs.cloudfileLeft.getFolderTotal();
      } else {
        this.pid = data.id;
        this.ids = data.ids;
      }
    },
    handleIsOK: function handleIsOK() {
      if (this.switchIndex === 6) {
        this.$refs.spaceFile.getTreeData(1);
      } else {
        this.$refs.myFile.getTreeData(1);
      }
    },
    // 上传成功
    handleSuccess: function handleSuccess(response) {
      if (response.status === 200) {
        this.$message.success(response.message);
        if (this.switchIndex === 6) {
          this.$refs.spaceFile.getTreeData();
        } else {
          this.$refs.myFile.getTreeData();
        }
      } else {
        this.$message.error(response.message);
      }
    },
    recoveryBtn: function recoveryBtn() {
      this.switchIndex = 7;
    },
    // returnSpace() {
    //   this.switchIndex = 6
    //   this.entButton = false
    //   setTimeout(() => {
    //     this.$refs.spac eFile.where.page = 1
    //     this.$refs.spaceFile.getTreeData()
    //     this.$refs.spaceFile.menuIds = []
    //   }, 200)
    // },
    handleTemplate: function handleTemplate() {
      this.getFileList();
    },
    allDelete: function allDelete(type) {
      var _this5 = this;
      if (this.ids.length <= 0) {
        this.$message.error(this.$t('file.placeholder05'));
      } else {
        var uids = this.ids;
        if (uids.length > 0 && uids[0] === 0) {
          uids.splice(0, 1);
        }
        if (type === 1) {
          this.getFolderAllDelete({
            id: uids
          });
        } else if (type === 2) {
          if (this.entButton) {
            // 企业空间
            this.$modalSure('彻底删除后,内容无法恢复,你确定要删除该内容吗').then(function () {
              _this5.getFolderEntAllDestroy(_this5.spaceId, {
                id: uids
              });
            });
          } else {
            this.$modalSure('彻底删除后,内容无法恢复,你确定要删除该内容吗').then(function () {
              _this5.getFolderAllDestroy({
                id: uids
              });
            });
          }
        } else if (type === 3) {
          this.$modalSure('你确定要删除该内容吗').then(function () {
            _this5.getFolderEntAllDelete(_this5.spaceId, {
              id: uids
            });
          });
        }
      }
    },
    allDestroy: function allDestroy() {
      if (this.ids.length <= 0) {
        this.$message.error(this.$t('file.placeholder06'));
      } else {
        var uids = this.ids;
        if (uids.length > 0 && uids[0] === 0) {
          uids.splice(0, 1);
        }
        if (this.entButton) {
          // 企业空间
          this.getFolderEntAll(this.spaceId, {
            id: uids
          });
        } else {
          this.getFolderAllFile({
            id: uids
          });
        }
      }
    },
    allMove: function allMove() {
      if (this.ids.length <= 0) {
        this.$message.error(this.$t('file.placeholder07'));
      } else {
        var uids = this.ids;
        if (uids.length > 0 && uids[0] === 0) {
          uids.splice(0, 1);
        }
        if (this.switchIndex == 6) {
          this.moveData.id = uids;
          this.moveData.type = 4;
          this.moveData.fid = this.spaceId;
          this.$refs.moveDialog.handleOpen();
        } else {
          this.moveData.id = uids;
          this.moveData.type = 2;
          this.$refs.moveDialog.handleOpen();
        }
      }
    },
    // 移动回调
    handlerMove: function handlerMove(data) {
      if (data.type === 2 || data.type === 4) {
        this.getFileList();
      }
    },
    // 批量删除文件（我的文件）
    getFolderAllDelete: function getFolderAllDelete(data) {
      var _this6 = this;
      folderAllDeleteApi(data).then(function (res) {
        _this6.getFileList();
      });
    },
    // 批量彻底删除文件（我的文件）
    getFolderAllDestroy: function getFolderAllDestroy(data) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return folderAllDestroyApi(data);
            case 2:
              _context.next = 4;
              return _this7.getFileList();
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 批量恢复文件（我的文件）
    getFolderAllFile: function getFolderAllFile(data) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return folderAllDestroyFileApi(data);
            case 2:
              _context2.next = 4;
              return _this8.getFileList();
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 批量删除文件（企业空间）
    getFolderEntAllDelete: function getFolderEntAllDelete(id, data) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return folderSpaceEntAllDeleteApi(id, data);
            case 2:
              _context3.next = 4;
              return _this9.getFileList();
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    // 批量彻底删除文件（企业空间）
    getFolderEntAllDestroy: function getFolderEntAllDestroy(id, data) {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return folderSpaceEntAllDestroyApi(id, data);
            case 2:
              _context4.next = 4;
              return _this10.getFileList();
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    // 批量恢复删除文件（企业空间）
    getFolderEntAll: function getFolderEntAll(id, data) {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return folderSpaceEntAllRecoverApi(id, data);
            case 2:
              _context5.next = 4;
              return _this11.getFileList();
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    }
  }
};